import { Directive, Input, Output, EventEmitter } from '@angular/core';

@Directive({ 
    selector: '[mp-capitalize]',
    host: {
        "(input)": 'onInputChange($event)'
    }
})
export class CapitalizeDirective {
    @Output() ngModelChange:EventEmitter<any> = new EventEmitter()    
    @Input('mp-capitalize') public mpcapitalize: any;
    // @Input() public input: any;

    // constructor(private el: ElementRef) { }

    onInputChange($e) {
        console.log($e.target.value)
        $e.target.value = 'ddd'
        // this.ngModelChange.emit($e.target.value.toUpperCase())
    }

    // @HostListener('change') onChange() {
    //     console.log(this.el)
    //     // this.el.nativeElement.value.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()})
    // }

}


// @Directive({
//     selector: '[number]'
// })
// export class NumberDirective implements OnChanges {
//     @Input() public number: any;
//     @Input() public input: any;

//     ngOnChanges(changes){
//       if(changes.input){
//         console.log('input changed');
//       }
//     }
// }


// WEBPACK FOOTER //
// ./src/directives/mp.directive.ts